import { useCallback, useEffect, useState } from "react"
import api from "../lib/api"

export type CatalogItemCategory = "structure" | "electronics" | "launch_equipment" | "merchandising"

export interface CatalogItem {
  id: string
  name: string
  description: string
  imageUrl: string | null
  priceCop: number
  category: CatalogItemCategory
}

interface CccdCatalogState {
  items: CatalogItem[]
  isLoading: boolean
  error: string | null
}

const initialState: CccdCatalogState = { items: [], isLoading: true, error: null }

/** Catálogo de construcción/decoración habilitado para el evento del equipo
 * (sesión `group`) — ver openspec/changes/cccd-team-supply-catalog. Nunca se
 * cobra: solo alimenta la solicitud que el equipo puede enviar desde
 * `GroupDashboard`. Solo tiene sentido para una sesión de equipo — un
 * estudiante individual no tiene este endpoint disponible. */
export function useCccdCatalog(enabled: boolean) {
  const [state, setState] = useState<CccdCatalogState>(initialState)

  const refetch = useCallback(() => {
    if (!enabled) {
      setState({ ...initialState, isLoading: false })
      return
    }
    setState((prev) => ({ ...prev, isLoading: true, error: null }))
    api
      .get("/cccd/me/catalog")
      .then(({ data }) => setState({ items: data.data?.items ?? [], isLoading: false, error: null }))
      .catch(() => setState({ items: [], isLoading: false, error: "No se pudo cargar el catálogo." }))
  }, [enabled])

  useEffect(() => {
    refetch()
  }, [refetch])

  return { ...state, refetch }
}

export async function submitSupplyRequest(items: { catalogItemId: string; quantity: number }[]) {
  await api.post("/cccd/me/supply-requests", { items })
}
